/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type UpdateLoginLinkRedirectUriInput = {
  redirectURI: string;
};

export type LineActivationManagerPageQueryVariables = Exact<{ [key: string]: never; }>;


export type LineActivationManagerPageQuery = { lineActivationProviderLiffAppConfig: { clientId: string, liffId: string, loginRedirectUri: string, canEditRedirectURI: boolean } | null };

export type LineActivationManagerPageExportUsersQueryVariables = Exact<{
  first: number;
  after?: string | null | undefined;
}>;


export type LineActivationManagerPageExportUsersQuery = { okanentClientUsersForForeignUser: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ cursor: string, node: { id: string, foreignUserID: string | null, user: { chatRoom: { id: string } | null } } }> } };

export type UpdateLoginLinkRedirectUriMutationVariables = Exact<{
  input: Types.UpdateLoginLinkRedirectUriInput;
}>;


export type UpdateLoginLinkRedirectUriMutation = { updateLoginLinkRedirectURI: { void: any } };


export const LineActivationManagerPageDocument = gql`
    query LineActivationManagerPage {
  lineActivationProviderLiffAppConfig {
    clientId
    liffId
    loginRedirectUri
    canEditRedirectURI
  }
}
    `;

/**
 * __useLineActivationManagerPageQuery__
 *
 * To run a query within a Vue component, call `useLineActivationManagerPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLineActivationManagerPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLineActivationManagerPageQuery();
 */
export function useLineActivationManagerPageQuery(options: VueApolloComposable.UseQueryOptions<LineActivationManagerPageQuery, LineActivationManagerPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LineActivationManagerPageQuery, LineActivationManagerPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LineActivationManagerPageQuery, LineActivationManagerPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LineActivationManagerPageQuery, LineActivationManagerPageQueryVariables>(LineActivationManagerPageDocument, {}, options);
}
export function useLineActivationManagerPageLazyQuery(options: VueApolloComposable.UseQueryOptions<LineActivationManagerPageQuery, LineActivationManagerPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LineActivationManagerPageQuery, LineActivationManagerPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LineActivationManagerPageQuery, LineActivationManagerPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LineActivationManagerPageQuery, LineActivationManagerPageQueryVariables>(LineActivationManagerPageDocument, {}, options);
}
export type LineActivationManagerPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LineActivationManagerPageQuery, LineActivationManagerPageQueryVariables>;
export const LineActivationManagerPageExportUsersDocument = gql`
    query LineActivationManagerPageExportUsers($first: Int!, $after: String) {
  okanentClientUsersForForeignUser(first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      cursor
      node {
        id
        foreignUserID
        user {
          chatRoom {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useLineActivationManagerPageExportUsersQuery__
 *
 * To run a query within a Vue component, call `useLineActivationManagerPageExportUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLineActivationManagerPageExportUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLineActivationManagerPageExportUsersQuery({
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useLineActivationManagerPageExportUsersQuery(variables: LineActivationManagerPageExportUsersQueryVariables | VueCompositionApi.Ref<LineActivationManagerPageExportUsersQueryVariables> | ReactiveFunction<LineActivationManagerPageExportUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<LineActivationManagerPageExportUsersQuery, LineActivationManagerPageExportUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LineActivationManagerPageExportUsersQuery, LineActivationManagerPageExportUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LineActivationManagerPageExportUsersQuery, LineActivationManagerPageExportUsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LineActivationManagerPageExportUsersQuery, LineActivationManagerPageExportUsersQueryVariables>(LineActivationManagerPageExportUsersDocument, variables, options);
}
export function useLineActivationManagerPageExportUsersLazyQuery(variables?: LineActivationManagerPageExportUsersQueryVariables | VueCompositionApi.Ref<LineActivationManagerPageExportUsersQueryVariables> | ReactiveFunction<LineActivationManagerPageExportUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<LineActivationManagerPageExportUsersQuery, LineActivationManagerPageExportUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LineActivationManagerPageExportUsersQuery, LineActivationManagerPageExportUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LineActivationManagerPageExportUsersQuery, LineActivationManagerPageExportUsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LineActivationManagerPageExportUsersQuery, LineActivationManagerPageExportUsersQueryVariables>(LineActivationManagerPageExportUsersDocument, variables, options);
}
export type LineActivationManagerPageExportUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LineActivationManagerPageExportUsersQuery, LineActivationManagerPageExportUsersQueryVariables>;
export const UpdateLoginLinkRedirectUriDocument = gql`
    mutation UpdateLoginLinkRedirectURI($input: UpdateLoginLinkRedirectURIInput!) {
  updateLoginLinkRedirectURI(input: $input) {
    ... on UpdateLoginLinkRedirectURISuccessPayload {
      void
    }
  }
}
    `;

/**
 * __useUpdateLoginLinkRedirectUriMutation__
 *
 * To run a mutation, you first call `useUpdateLoginLinkRedirectUriMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoginLinkRedirectUriMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateLoginLinkRedirectUriMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLoginLinkRedirectUriMutation(options: VueApolloComposable.UseMutationOptions<UpdateLoginLinkRedirectUriMutation, UpdateLoginLinkRedirectUriMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateLoginLinkRedirectUriMutation, UpdateLoginLinkRedirectUriMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateLoginLinkRedirectUriMutation, UpdateLoginLinkRedirectUriMutationVariables>(UpdateLoginLinkRedirectUriDocument, options);
}
export type UpdateLoginLinkRedirectUriMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateLoginLinkRedirectUriMutation, UpdateLoginLinkRedirectUriMutationVariables>;